'use strict';
(() => {
  const connection = navigator.connection;
  const canPrefetch = matchMedia('(pointer: fine)').matches
    && !connection?.saveData
    && !['slow-2g', '2g'].includes(connection?.effectiveType);
  const prefetchedProducts = new Set();

  const prefetchCustomizer = productId => {
    if (!canPrefetch || !productId || prefetchedProducts.has(productId)) return;
    prefetchedProducts.add(productId);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = `https://customizer.coozebra.com/customizer/?product_id=${encodeURIComponent(productId)}`;
    document.head.append(link);
  };

  const mount = root => root.querySelectorAll('[data-co-customizer-intent]').forEach(link => {
    if (link.dataset.coCustomizerIntentBound) return;
    link.dataset.coCustomizerIntentBound = 'true';
    const prefetch = () => prefetchCustomizer(link.dataset.coCustomizerIntent);
    link.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse') prefetch();
    }, { passive: true });
    link.addEventListener('focusin', prefetch, { passive: true });
  });

  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
